const mapStateToProps = state => 
    ({
        registroHomonimosSeleccionadoModuloFallecidos: state.fallecidos.registroHomonimosSeleccionadoModuloFallecidos,
        catalogos: state.fallecidos.catalogos,
    });
export default mapStateToProps;
